import { apiClient } from '.';

export interface StudyCategory {
  id: number;
  name: string;
  slug: string;
  sort_order: number;
}

export interface StudyCategoryListResponse {
  code: number;
  status: string;
  message: string;
  data: StudyCategory[];
}

// 스터디 카테고리 목록 조회
export const getStudyCategories = async (): Promise<StudyCategoryListResponse> => {
  try {
    const { data } = await apiClient.get<StudyCategoryListResponse>('/api/study-categories/list');
    return data;
  } catch (error) {
    /// console.error('스터디 카테고리 목록 조회 실패:', error);
    throw error;
  }
};

// 별칭 추가 (기존 코드와의 호환성)
export const getStudyCategoriesList = getStudyCategories;
